import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";

import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";
import { qrYoutubeValidation } from "@/utils/validators/qr-youtube";
import { QRYoutubeProps } from "./types";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const QRYoutube = ({ data }: QRYoutubeProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const [youtubeUrl, setYoutubeUrl] = React.useState("");
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"youtube">>(QREditorContext);

  const [qrYoutubeData, setQrYoutubeData] = React.useState<QRProps<"youtube">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataYoutubeWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  onBindClick(dataYoutubeWithDefaultValues, "youtubeButton", () => {
    setQrData({
      ...qrData,
      data: {
        ...qrData.data,
        youtubeUrl,
      },
    });
  });

  const onUpdateState = ({ field, value }) => {
    if (field == "") return;
    if (field === "youtubeUrl") {
      setYoutubeUrl(value);
      return;
    }

    setQrData({
      ...qrData,
      data: {
        ...qrData.data,
        [field]: value,
      },
    });
  };

  React.useEffect(() => {
    setQrYoutubeData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrYoutubeData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-youtube">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataYoutubeWithDefaultValues}
        schema={qrYoutubeValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
